import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  // Card,
  // CardBody,
  Modal,
  // Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  FormGroup,
  Input,
  Label,
  Table,
  Badge,
  CustomInput,
  InputGroup,
  InputGroupAddon,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Select from "react-select";
import {
  SetParams,
  getLocations,
  getSubLocations,
  getDepartment,
  getUsers,
  getRowUserData,
  getDeptSelectFiled,
  removeDeptSelectFiled,
  removeLocSelectFiled,
  getLocSelectFiled,
  SelecteChangeLocValue,
  MultiSelecteChangeSubLocValue,
  SelecteChangeDeptValue,
  getHODChecked,
  InputChangeValue,
  SelecteChangeValue,
  MultiSelecteChangeValue,
  model_open,
  model_close,
  userAdd,
  userEdit,
  userDelete,
  apiError,
  getGroupsList,
  SetProfileParams
} from "../../../store/CompanySettings/users/actions";

// import { Link } from "react-router-dom";

import {
  AvForm,
  // AvCheckbox,
  // AvGroup,
  // AvField,
  // AvInput,
} from "availity-reactstrap-validation";

import swal from "sweetalert";
import "./datatables.scss";
// import { Link } from "react-router-dom/cjs/react-router-dom.min";
// import Input from "react-select/src/components/input";

//import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// const optionGroupRole = [
//   {
//     options: [
//       { label: "Admin", value: "Admin" },
//       { label: "Manager", value: "Manager" },
//     ],
//   },
// ];
// const optionGroupZone = [
//   {
//     options: [
//       { label: "Developer", value: "Developer" },
//       { label: "Suport", value: "Suport" },
//     ],
//   },
// ];
// const optionGroupGender = [
//   {
//     options: [
//       { label: "Male", value: "Male" },
//       { label: "Female", value: "Female" },
//     ],
//   },
// ];

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAlertOpen: false,
      selectedGroupRole: null,
      // selectedGroupZone: null,
      selectedGroupGender: null,

      passwordtext: null,
      username: null,
      first_name: null,
      last_name: null,
      email: null,
      mobile: null,
      location: null,
      location_id: 0,
      location_name: "Select Location",
      pass_disabled: false,
    };
    // this.tog_static = this.tog_static.bind(this);
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.getinpu = this.getinpu.bind(this);
    this.removeFiled = this.removeFiled.bind(this);
  }
  // tog_static() {
  //   this.setState((prevState) => ({
  //     modal_static: !prevState.modal_static,
  //   }));
  //   this.removeBodyCss();
  // }

  // removeBodyCss() {
  //   document.body.classList.add("no_padding");
  // }

  handleSelectGroupRole = (selectedGroupRole) => {
    this.setState({ selectedGroupRole });
  };
  // handleSelectGroupZone = (selectedGroupZone) => {
  //   this.setState({ selectedGroupZone });
  // };
  handleSelectGroupGender = (selectedGroupGender) => {
    this.setState({ selectedGroupGender });
  };

  handleDelete(values) {
    this.props.userDelete(values, this.props.history);
  }
    openPage(pageNo) {
      this.props.SetParams({ ...this.props.profileParams, page: pageNo });
      this.props.getGroupsList({ ...this.props.profileParams, page: pageNo });
    }
  addUserPop = () => {
    this.setState({
      id: 0,
      username: null,
      first_name: null,
      last_name: null,
      email: null,
      mobile: null,
      location: null,
      location_name: "Select Location",
      pass_disabled: false,
    });

    this.props.model_open();
  };

  deleteRecord = (record) => {
   
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.handleDelete(record.id);
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  handleChange(event) {
    var pass = event.target.value;
    // var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    var regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})");
    if (!regex.test(pass)) {
      swal(
        "Sorry! Please Check Password 8 Characters Length and One Character Upper And One Special Charector"
      );
      this.setState({ passwordtext: "" });
    }

    // var reg = '?=.*[A-Z]';
    // var test = reg.test(pass);
    // if (test) {
    //   alert('pass');
    //   this.setState({value: pass});
    // }else{
    //   alert('fail');
    // }
  }
  //-----------------------------
  componentDidMount() {
    this.props.getUsers({ ...this.props.params, page: 1, search: "" });
    this.props.getLocations();
    this.props.getSubLocations();
    this.props.getDepartment();
    this.props.apiError();
  }

  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  removeFiled(id) {
    this.props.removeDeptSelectFiled(id);
  }
  removeLocFiled(id) {
    this.props.removeLocSelectFiled(id);
  }

  getCheckedRequest(e, id, index) {
   
    this.props.getHODChecked(e.target.checked, id, index);
  }
  handleValidSubmit() {
    var sublocationIds = [];
    var locationIds = this.props.inputLocList.map((Loc) => {
      var sl = Loc.subLocations.map((subLoc) => {
        return subLoc.value;
      });
      sublocationIds.push(sl);
      return Loc.location_id;
    });

    var data = this.props.UserRowData;
    var UserData = {
      id: data.id,
      username: data.username,
      password: data.password,
      phone: data.phone,
      first_name: data.first_name,
      last_name: data.last_name,
      location_ids: locationIds,
      sublocation_ids: [].concat.apply([], sublocationIds),
    };
    if( data.email ){
      UserData.email = data.email
    }
    var Userdata2 = {
      department_ids: this.props.inputDeptList.map((dept) => {
        return dept.department_id;
      }),
      hod_to_department_ids: this.props.hodIds,
      group_ids: data.groups.map((groups) => {
        return groups.value;
      }),
    };
   
    if (UserData.id == null) {
      this.props.userAdd(UserData, Userdata2);
    } else {
      this.props.userEdit(UserData, Userdata2);
    }
  }
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getUsers({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getUsers({ ...this.props.params, page: pageNo });
  }
  scrooFunc = async (pageNo) => {
    if (this.props.loading) return; // Prevent multiple requests
  
    // Update loading state
  
    const updatedParams = { ...this.props.profileParams, page: pageNo };
    this.props.SetProfileParams(updatedParams);
  
    const newData = await this.props.getGroupsList(updatedParams, false);
  
    if (newData && Array.isArray(newData) && newData.length > 0) {
      this.props.updateGroupsList([...this.props.groupsList, ...newData]);
    } else {
      // Stop pagination when no more data
    }
  
    // Reset loading state

  };
  
  
  handleScroll = (e) => {
    const target = e.target;
  
    // Prevent unnecessary API calls if already loading
    if (this.props.loading) return;
  
    // Detect Scroll Down & Trigger Pagination
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      if (this.props.profileParams.page < this.props.profileParams.no_of_pages) {
        const nextPage = this.props.profileParams.page + 1;
        this.scrooFunc(nextPage);
      }
    }
  };
  
  // Attach a ref to track the scroll container
  setScrollRef = (ref) => {
    this.scrollContainerRef = ref;
  };
  
  
  
  render() {
 
    var rdata = this.props.UserRowData;

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={6} xl={6}>
              <div className="text-left">
                <h5 className="card-title-18">Users information</h5>
              </div>
            </Col>
            <Col xs={6} xl={6}>
              <div className="float-right">
                <Button
                  type="button"
                  color="primary"
                  className="waves-effect waves-light"
                  onClick={this.addUserPop.bind()}
                >
                  Add User
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Row>
                <Col md={4}>
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) =>
                          this.props.SetParams({
                            ...this.props.params,
                            search: e.target.value,
                            page: 1,
                          })
                        }
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getUsers({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={8}>
                  <div className="float-right">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          first
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          last
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                </Col>
              </Row>
              <div className="table-responsive m-0 mt-2">
                <Table bordered hover className="mb-0 p-0 table-centered">
                  <thead className="bg-light text-center">
                    <tr>
                      <th className="nowrap">S.No</th>
                      <th className="nowrap">User Name</th>
                      <th className="nowrap">Full Name</th>
                      <th className="nowrap">Email</th>
                      <th className="nowrap">Mobile</th>
                      <th className="nowrap">Roles</th>
                      <th className="nowrap">Departments</th>
                      <th className="nowrap">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.Userslist?.map((user, key) => (
                      <tr key={key}>
                         <td className="text-center">
                          {this.props.params.page_size * (this.props.params.page - 1) + (key + 1)}
                          </td>
                        <td>{user.username}</td>
                        <td>{user.first_name} {user.last_name}</td>
                        <td>
                          {user.email}{" "}
                          {user.email && user.is_email_verified === "True" && (
                            <Badge color="success" pill className="p-2">
                              Verified
                            </Badge>
                          )}
                          {user.email && user.is_email_verified === "False" && (
                            <Badge color="danger" pill className="p-2">
                              {/* <i className="mdi mdi-close-circle-outline"></i> */}
                              Not Verified
                            </Badge>
                          )}
                        </td>
                        <td>
                          {user.phone}{" "}
                          {user.phone && user.is_phone_verified === "True" &&
                            (
                              <Badge color="success" pill className="p-2">
                                Verified
                              </Badge>
                            )}
                          {user.phone && user.is_phone_verified === "False" &&
                            (
                              <Badge color="danger" pill className="p-2">
                                {/* <i className="mdi mdi-close-circle-outline"></i> */}
                                Not Verified
                              </Badge>
                            )}
                        </td>
                        <td>{user.groups.map(g=>g.name+" , ")}</td>
                        <td>{user.departments.map(d=>d.name+" , ")}</td>
                        <td className=" text-center">
                          <Button
                            outline
                            type="button"
                            color="success"
                            className="waves-effect waves-light mr-2"
                            onClick={() => {
                              this.props.getRowUserData(user.id);
                            }}
                          >
                            <i className="mdi mdi-border-color"></i>
                          </Button>
                          <Button
                            outline
                            type="button"
                            color="danger"
                            className="waves-effect waves-light"
                            onClick={() => {
                              this.deleteRecord(user);
                            }}
                          >
                            <i className="mdi mdi-delete-forever"></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          <Modal
            isOpen={this.props.model}
            // toggle={this.tog_static}
            backdrop="static"
            centered
            size="lg"
          >
            <ModalHeader toggle={() => this.props.model_close()}>
              Add User
            </ModalHeader>
            <ModalBody>
              <AvForm autocomplete="off" onValidSubmit={this.handleValidSubmit}>
                <Row className="justify-content-center">
                  <Col md={12}>
                    <Alert
                      color="success"
                      isOpen={this.state.isAlertOpen}
                      toggle={() => this.setState({ isAlertOpen: false })}
                    >
                      User Added Successfully...!
                    </Alert>

                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Label className="text-primary mt-1">
                          User Login Details
                        </Label>
                        <hr className="my-0" />
                      </Col>

                      <Col md={5}>
                        <FormGroup className="mb-0">
                          <Label htmlFor="username" className="col-form-label ">
                            Username
                          </Label>

                          <Input
                            name="username"
                            autocomplete="off"
                            type="text"
                            value={rdata.username}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="username"
                            placeholder="Enter Name"
                            errormessage=" Please provide a valid Username"
                            validate={{ required: { value: true } }}
                          />
                          {this.props.error_msg?.username != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.username}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-1">
                          <Label htmlFor="Password" className="col-form-label ">
                            Password
                          </Label>

                          <Input
                            name="password"
                            type="password"
                            autocomplete="off"
                            value={rdata.password}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="Password"
                            placeholder="Enter Name"
                            errormessage=" Please provide a valid Password"
                            validate={{ required: { value: true } }}
                            // disabled={this.state.pass_disabled}
                            // onBlur={this.handleChange}
                          />
                          {this.props.error_msg?.password != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.password}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Label className="text-primary mt-1">
                          User Details
                        </Label>
                        <hr className="my-0" />
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-0">
                          <Label
                            htmlFor="first_name"
                            className="col-form-label"
                          >
                            First Name
                          </Label>

                          <Input
                            name="first_name"
                            type="text"
                            value={rdata.first_name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="first_name"
                            placeholder="Enter First Name"
                            errormessage=" Please provide a valid First Name"
                            validate={{ required: { value: true } }}
                          />
                          {this.props.error_msg?.first_name != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.first_name}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-0">
                          <Label htmlFor="last_name" className="col-form-label">
                            Last Name
                          </Label>

                          <Input
                            name="last_name"
                            type="text"
                            value={rdata.last_name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="last_name"
                            placeholder="Enter Last Name"
                            errormessage=" Please provide a valid Last Name"
                            validate={{ required: { value: true } }}
                          />
                          {this.props.error_msg?.last_name != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.last_name}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-0">
                          <Label htmlFor="email" className="col-form-label">
                            Email ID
                          </Label>

                          <Input
                            name="email"
                            type="email"
                            value={rdata.email}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="email"
                            placeholder="Enter Email"
                            errormessage=" Please provide a valid Email"
                            validate={{ required: { value: true } }}
                          />
                          {this.props.error_msg?.email != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.email}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="mb-1">
                          <Label htmlFor="phone" className="col-form-label ">
                            Mobile No
                          </Label>

                          <Input
                            name="phone"
                            mask="(999) 999-9999"
                            type="tel"
                            value={rdata.phone}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="phone"
                            placeholder="Enter Mobile No"
                            errormessage=" Please provide a valid Mobile No"
                            validate={{ required: { value: true } }}
                          />
                          {this.props.error_msg?.phone != null && (
                            <Label className="text-danger m-0">
                              {this.props.error_msg?.phone}
                            </Label>
                          )}
                        </FormGroup>
                      </Col>{" "}
                      <Col md={5}>
                      <FormGroup>
                      <Label className="Role-selection col-form-label">Select Role</Label>
                       <div                      
                       ref={(ref) => (this.scrollContainerRef = ref)}
                      onScroll={this.handleScroll}
                       >
                        {console.log("this.props.groupsList",this.props.groupsList)}
                      <Select
                        isMulti
                        options={this.props.groupsList?.map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        value={this.props.UserRowData && this.props.UserRowData.groups}
                        onChange={(multiValues) =>
                          this.props.MultiSelecteChangeValue("groups", multiValues)
                        }
                        onFocus={() => {
                          this.props.getGroupsList({...this.props.profileParams,page: 1}); // Call your API function here
                        }}
                        // onScroll={this.handleScroll}
                        name="Role-selection"
                        classNamePrefix="Role-selection"
                        id="Role-selection"
                        errormessage="Please provide a valid Role"
                        validate={{ required: { value: true } }}
                      />
                      </div>
                    </FormGroup>
                      </Col>{" "}
                      <Col md={5}></Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Label className="text-primary m-0">
                          User Departments
                        </Label>
                        <hr className="my-0" />
                      </Col>

                      {/* {this.getinpu(this.props.inputDeptList)} */}
                      {this.props.inputDeptList.map((inputDept, i) => {
                        return (
                          <>
                            <Col md={10}>
                              <FormGroup row className="mb-0">
                                <Col md={6}>
                                  <Label className="col-form-label ">
                                    Select Departments
                                  </Label>

                                  <Select
                                    id="Departments"
                                    name="Departments"
                                    classNamePrefix="select-vendorlist"
                                    options={this.props.deparmentslist.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label: inputDept.departmentLabel,
                                      value: inputDept.department_id,
                                    }}
                                    onChange={(e) => {
                                      this.props.SelecteChangeDeptValue({
                                        key: "departmentLabel",
                                        label: e.label,
                                        key2: "department_id",
                                        value: e.value,
                                        i,
                                      });
                                    }}
                                  />
                                </Col>
                                <Col
                                  md={2}
                                  // className="d-flex align-items-center "
                                >
                                  <Label className="col-form-label ">
                                    &nbsp;
                                  </Label>

                                  <FormGroup
                                    row
                                    className="mb-1 d-flex align-items-center "
                                  >
                                    <Col md={3}>
                                      <CustomInput
                                        type="checkbox"
                                        name="deptCheckbox"
                                        id={"deptCheckbox" + inputDept.id}
                                        disabled={
                                          inputDept.department_id === ""
                                            ? true
                                            : false
                                        }
                                        checked={inputDept.Deptcheck}
                                        onChange={(e) => {
                                          this.getCheckedRequest(
                                            e,
                                            inputDept.id,
                                            i
                                          );
                                        }}
                                      />
                                    </Col>
                                    <Col md={9}>
                                      <Label
                                        htmlFor={
                                          "deptCheckbox" +
                                          inputDept.department_id
                                        }
                                        className="col-form-label "
                                      >
                                        HOD
                                      </Label>
                                    </Col>
                                  </FormGroup>
                                </Col>
                                <Col
                                  md={3}
                                  // className="d-flex align-items-center  "
                                >
                                  <Label className="col-form-label ">
                                    &nbsp;
                                  </Label>
                                  <div className="btn-box">
                                    {this.props.inputDeptList.length !== 1 && (
                                      <Button
                                        outline
                                        color="danger"
                                        size="sm"
                                        className="mr-2"
                                        onClick={() =>
                                          this.removeFiled(inputDept.id)
                                        }
                                      >
                                        <i className="mdi mdi-close-circle-outline mdi-18px"></i>
                                      </Button>
                                    )}
                                    {this.props.inputDeptList.length - 1 ===
                                      i && (
                                      <Button
                                        outline
                                        color="primary"
                                        size="sm"
                                        disabled={
                                          inputDept.department_id === ""
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          this.props.getDeptSelectFiled(
                                            this.props.inputDeptList[
                                              this.props.inputDeptList.length -
                                                1
                                            ].id
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-plus-circle-outline mdi-18px"></i>
                                      </Button>
                                    )}
                                  </div>
                                </Col>
                              </FormGroup>
                            </Col>
                            <Col md={6}></Col>
                          </>
                        );
                      })}
                    </Row>
                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Label className="text-primary mt-1">
                          User Locations
                        </Label>
                        <hr className="my-0" />
                      </Col>
                      {this.props.inputLocList.map((loc, i) => {
                        return (
                          <>
                            <Col md={10}>
                              <Row>
                                <Col md={5}>
                                  <FormGroup>
                                    <Label className="Location-selection col-form-label">
                                      Select Location
                                    </Label>

                                    <Select
                                      options={this.props.locationslist.map(
                                        (item, index) => ({
                                          label: item.name,
                                          value: item.id,
                                        })
                                      )}
                                      value={{
                                        label: loc.locationLabel,
                                        value: loc.location_id,
                                      }}
                                      onChange={(e) => {
                                        // this.props.getSubLocations(e.value);
                                        this.props.SelecteChangeLocValue({
                                          key: "locationLabel",
                                          label: e.label,
                                          key2: "location_id",
                                          value: e.value,
                                          i,
                                        });
                                      }}
                                      // value={
                                      //   this.props.UserRowData &&
                                      //   this.props.UserRowData.Locations
                                      // }
                                      // onChange={(multiValues) =>
                                      //   this.props.MultiSelecteChangeValue(
                                      //     "Locations",
                                      //     multiValues
                                      //   )
                                      // }
                                      name="location-selection"
                                      classNamePrefix="Location-selection"
                                      id="Location-selection"
                                      errormessage=" Please provide a valid Location"
                                      validate={{ required: { value: true } }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={5}>
                                  <FormGroup>
                                    <Label className="Location-selection col-form-label ">
                                      Select Sub Location
                                    </Label>

                                    <Select
                                      isMulti
                                      options={this.props.sublocationslist
                                        ?.filter(
                                          (subloc) =>
                                            subloc.location ===
                                            loc.location_id
                                        )
                                        .map((item, index) => ({
                                          label: item.name,
                                          value: item.id,
                                        }))}
                                      value={loc && loc.subLocations}
                                      onChange={(multiValues) =>
                                        this.props.MultiSelecteChangeSubLocValue(
                                          multiValues,
                                          i
                                        )
                                      }
                                      name="location-selection"
                                      classNamePrefix="Location-selection"
                                      id="Location-selection"
                                      errormessage=" Please provide a valid Location"
                                      validate={{ required: { value: true } }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={2}>
                                  <Label className="col-form-label ">
                                    &nbsp;
                                  </Label>
                                  <div className="btn-box">
                                    {this.props.inputLocList.length !== 1 && (
                                      <Button
                                        outline
                                        color="danger"
                                        size="sm"
                                        className="mr-2"
                                        onClick={() =>
                                          this.removeLocFiled(loc.id)
                                        }
                                      >
                                        <i className="mdi mdi-close-circle-outline mdi-18px"></i>
                                      </Button>
                                    )}
                                    {this.props.inputLocList.length - 1 ===
                                      i && (
                                      <Button
                                        outline
                                        color="primary"
                                        size="sm"
                                        disabled={
                                          loc.department_id === ""
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          this.props.getLocSelectFiled(
                                            this.props.inputLocList[
                                              this.props.inputLocList.length - 1
                                            ].id
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-plus-circle-outline mdi-18px"></i>
                                      </Button>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>

                <ModalFooter>
                  <Button
                    type="button"
                    color="light"
                    onClick={() => this.props.model_close()}
                  >
                    Calcel
                  </Button>
                  <Button type="submit" color="primary">
                    {this.props.UserRowData.id == null
                      ? "Add User"
                      : "Update User"}
                  </Button>
                </ModalFooter>
              </AvForm>
            </ModalBody>
          </Modal>
        </Col>
      </Row>
    );
  }
}
const mapStatetoProps = (state) => {
  const {
    params,
    profileParams,
    locationslist,
    sublocationslist,
    deparmentslist,
    Userslist,
    UserRowData,
    groupsList,
    inputDeptList,
    hodIds,
    inputLocList,
    model,
    message,
    error_msg,
  } = state.Users;

  return {
    params,
    profileParams,
    locationslist,
    sublocationslist,
    deparmentslist,
    Userslist,
    UserRowData,
    inputDeptList,
    hodIds,
    inputLocList,
    groupsList,
    //--------------
    message,
    error_msg,
    model,
  };
};
export default connect(mapStatetoProps, {
  SetParams,
  getUsers,
  getRowUserData,
  getDeptSelectFiled,
  removeDeptSelectFiled,
  getLocSelectFiled,
  removeLocSelectFiled,
  SelecteChangeLocValue,
  MultiSelecteChangeSubLocValue,
  SelecteChangeDeptValue,
  getHODChecked,
  InputChangeValue,
  SelecteChangeValue,
  MultiSelecteChangeValue,
  model_open,
  model_close,
  userAdd,
  userEdit,
  getLocations,
  getSubLocations,
  getDepartment,
  userDelete,
  apiError,
  getGroupsList,
  SetProfileParams
})(Users);
